/* eslint no-underscore-dangle:0 */

import React from "react";
import ImageWithInformation from "../components/blocks/ImageWithInformation";
import ImageAndText from "../components/blocks/ImageAndText";
import Team from "../components/blocks/Team";
import Text from "../components/blocks/Text";
import EventList from "../components/blocks/EventList";
import NewsAndEvent from "../components/blocks/NewsAndEvent";
import Contact from "../components/blocks/Contact";
import DistributionLocation from "../components/blocks/DistributionLocation";

const mapping = {
    image_with_information: ImageWithInformation,
    image_and_text: ImageAndText,
    team: Team,
    text: Text,
    news_and_event: NewsAndEvent,
    contact: Contact,
    event_list: EventList,
    distribution_location: DistributionLocation
    // partner: Partner
};

export default function Blocks(blocks, elementClassName) {
    const mapped = [];

    blocks.forEach((block, index) => {
        const modelKey = block.model.apiKey || undefined;

        if (!Object.prototype.hasOwnProperty.call(mapping, modelKey)) {
            return;
        }

        const Element = mapping[modelKey];

        mapped.push(<Element key={`block--${index}`} className={elementClassName} {...block} />);
    });

    return mapped;
}
